import angular from "angular"
import Store from "../../../lib/org/store"

angular
  .module("uCountitUiApp")
  .controller("PathTreeCtrl", ($scope, $stateParams, usSpinnerService, HeaderSrv) => {
    // This page just pass Organization information to iframe
    ;(async () => {
      const store = await HeaderSrv.fetchCurrentStore()
      if (store.orgType == Store.ORG_TYPE) {
        usSpinnerService.spin("spinner")
        $scope.onLoad = () => {
          usSpinnerService.stop("spinner")
        }

        const queryParams = ["from", "to"]
          .filter((key) => $stateParams[key])
          .map((key) => `${key}=${encodeURIComponent($stateParams[key])}`)
          .join("&")
        const search = queryParams ? `?${queryParams}` : ""
        $scope.pathtreeSrc = `/v2/embed/contents/path-tree/stores/${store._id}${search}`
      }
    })()
  })
